import { createReducer, on } from '@ngrx/store';

import { FlightResultsMobileBySector, AirBySectorResults } from '@app/entities/flight-results';
import * as actions from '@flight-results/store/actions/flights-results.actions';
import { exchangeSearchAction } from '@user-history/store/actions/user-history.actions';
import { fetchUpsellOptionsErrorBySectorAction } from '@upsell/store/actions/upsell.actions';

export const initialFlightResultsMobileBySectorState: FlightResultsMobileBySector[] = [];

export const flightResultsMobileBySectorReducer = createReducer(
  initialFlightResultsMobileBySectorState,
  on(actions.fetchAirResultsBySectorSuccessAction, (state, { flightResults }) => {
    return state.concat((flightResults.Results as AirBySectorResults).AirResults);
  }),
  on(
    exchangeSearchAction,
    fetchUpsellOptionsErrorBySectorAction,
    actions.clearFlightResultsAction,
    actions.saveFlightSearchData,
    actions.searchFlightsForMobileErrorAction,
    actions.searchFlightsForDesktopErrorAction,
    () => initialFlightResultsMobileBySectorState
  ),
);
